import React from 'react';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from 'reducers/index';
import type { WProjectCustomizationElementView } from '@zola/svc-web-api-ts-client';

// Actions
import { actions as projectActions } from '../../../actions/projectActions';

// Utilities
import { getImageUrl } from '../../../util/imageHelper';

// Styles
import './ImageLayer.less';

const StyledImageContainer = styled.div<{
  dragging: boolean;
  isActive: boolean;
  isDisabled: boolean;
}>`
  border: 1px solid transparent;
  background: transparent;

  ${({ dragging, isActive }) =>
    (dragging || isActive) &&
    `
		border: 1px solid #01b4c0;
	`}

  ${({ isActive, isDisabled }) =>
    !isActive &&
    !isDisabled &&
    `
		&:hover {
			border: 1px dashed #01b4c0;
		}
	`}
`;

const StyledImageWrapper = styled.div<{ deltas: any; dragging?: boolean }>`
  bottom: ${props => props.deltas.bottom}px;
  left: ${props => props.deltas.left}px;
  position: absolute;
  right: ${props => props.deltas.right}px;
  top: ${props => props.deltas.top}px;

  ${({ dragging }) =>
    dragging &&
    `
		border: 1px solid #01b4c0;
	`}
`;

// Types
interface SelectableImageLayerProps {
  imageElement: WProjectCustomizationElementView;
  isActive: boolean;
  isDisabled: boolean;
  deltas: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  };
  dragging: boolean;
}

const SelectableImageLayer: React.FC<SelectableImageLayerProps> = ({
  imageElement,
  isActive,
  isDisabled,
  deltas,
  dragging,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { uuid: imageUuid, image_id: imageId } = imageElement;

  const handleSelect = () => {
    if (!isActive) {
      dispatch(projectActions.setActiveField(imageUuid));
    }
  };

  if (!imageId) return null;

  return (
    <StyledImageContainer
      dragging={dragging}
      isActive={isActive}
      isDisabled={isDisabled}
      className="image-layer-content"
      onClick={handleSelect}
    >
      <StyledImageWrapper deltas={deltas} dragging={dragging}>
        <img
          className="image-layer-preview"
          src={getImageUrl(imageId)}
          alt="init Customizable Pic"
        />
      </StyledImageWrapper>
    </StyledImageContainer>
  );
};

export default SelectableImageLayer;
